export default "__VITE_ASSET__CICUydyZ__"